import React from "react";

const ArrowRightShowAll = props => (
  <svg viewBox="0 0 32 27" fill="none" {...props}>
    <path
      d="M31.107 13.785L17.982 26.363a.536.536 0 01-.752 0 .536.536 0 010-.752l12.168-11.69H1.234c-.341 0-.546-.204-.546-.546a.54.54 0 01.546-.547h28.164L17.23 1.207a.536.536 0 010-.752.536.536 0 01.752 0l13.125 12.578a.376.376 0 01.206.342c0 .205-.069.342-.206.41z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowRightShowAll;
